import axios from '../library/axiosConfig.js'
import api from './index'
import store from '../store'

function getSwitch() {
  return store.state.demotionSwitch;
}

export default {
  switch() {
    return axios.get('9_switch.json', {baseURL: axios.defaults.assetsMgzfFind})
  },
  cityList() {
    if (getSwitch())
      return axios.get('home/cityList/citys.json', {baseURL: axios.defaults.assetsMgzfFind, timeout: 1000 * 10})
    return api.roomFindWeb.cityList();
  },
  getMarketing (cityId) {
    if (getSwitch()){
      return axios.get('home/marketing/9_' + cityId + '.json', {baseURL: axios.defaults.assetsMgzfFind})
    }
    return api.mogoroomFind.getMarketing(cityId);
  },
  // 获取精选经纪人
  getFeaturedBrokers (cityId) {
    if (getSwitch())
      return axios.get(`home/featuredbrokers/9_${cityId}.json`, {baseURL: axios.defaults.assetsMgzfFind})
    return api.mogoroomFind.getFeaturedBrokers(cityId);
  },
  // 精选业主房源
  getBrokerRooms (cityId) {
    if (getSwitch())
      return axios.get(`home/brokerrooms/9_${cityId}.json`, {baseURL: axios.defaults.assetsMgzfFind})
    return api.mogoroomFind.getBrokerRooms(cityId);
  },
  // 优选品牌公寓
  getFeaturedBrands (cityId) {
    if (getSwitch())
      return axios.get(`home/featuredbrands/9_${cityId}.json`, {baseURL: axios.defaults.assetsMgzfFind})
    return api.mogoroomFind.getFeaturedBrands(cityId);
  },
  // 优选公寓房源
  getLandlordRooms (cityId) {
    if (getSwitch())
      return axios.get(`home/landlordrooms/9_${cityId}.json`, {baseURL: axios.defaults.assetsMgzfFind})
    return api.mogoroomFind.getLandlordRooms(cityId);
  },
  // 信用租状态
  getXyzStatus(){
    return axios.get(`/h5-static/xyz_channel_close.json`, {baseURL: axios.defaults.assetsMgzf});
  }
}



// WEBPACK FOOTER //
// ./src/api/assetsMgzfFind.js